import { Flex, Grid } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import MessageDisplay from './Messages/Messages';
import ConversationsList from './Conversations/Conversations';
import useConversationSocketEvents from './hooks/useConversationSocketEvents';
import useSocketSubscription from '../../Hooks/useSocketSubscription';
import { Resource } from '../../Constants/socket';
import { useGlobal } from '../Shared/GlobalContext/GlobalContext';

const { useBreakpoint } = Grid;

const Index = () => {
    const [conversations, setConversations] = useState([]);
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [showMessages, setShowMessages] = useState(false);
    const screens = useBreakpoint();
    const { user: { id: currentUserId } = {} } = useGlobal();

    // Subscribe to user-scoped channel instead of global resources
    useSocketSubscription(Resource.USER, currentUserId ? [currentUserId] : null, true);

    // Use the conversation socket events hook to handle real-time updates
    useConversationSocketEvents({
        setConversations,
        selectedConversation,
        setSelectedConversation
    });

    useEffect(() => {
        if (!screens.xs) {
            setShowMessages(false);
        }
    }, [screens.xs]);

    const handleConversationSelect = (conversation) => {
        setSelectedConversation(conversation);
        if (screens.xs) {
            const willShow = Boolean(conversation);
            setShowMessages(willShow);
            // Push a history entry every time we enter the messages view on mobile
            if (willShow) {
                try { window.history.pushState({ messageView: true }, ''); } catch (e) { }
            }
        }
    };

    const handleBack = useCallback(() => {
        setShowMessages(false);
    }, [setShowMessages]);

    // Centralized mobile back button behavior: works every time we open the message view
    useEffect(() => {
        if (!screens.xs) return;

        const handlePopState = (event) => {
            // If we are showing messages, back should go to conversations
            if (showMessages) {
                event?.preventDefault?.();
                setShowMessages(false);
                return;
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [screens.xs, showMessages]);

    return (
        <Flex
            style={{
                flexGrow: 1,
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
                borderRadius: 8,
                height: '100%',
                minHeight: 0,
            }}
        >
            <div
                style={{
                    display: screens.xs && showMessages ? 'none' : 'flex',
                    flex: screens.xs ? '1 0 100%' : '0 0 33.333%',
                    overflow: 'hidden',
                    flexGrow: 1,
                    flexShrink: 0,
                    minHeight: 0,
                }}
            >
                <ConversationsList
                    onSelectConversation={handleConversationSelect}
                    selectedId={selectedConversation?.id}
                    conversations={conversations}
                    setConversations={setConversations}
                    isMobile={Boolean(screens.xs)}
                />
            </div>
            <div
                style={{
                    display: screens.xs && !showMessages ? 'none' : 'flex',
                    flex: screens.xs ? '1 0 100%' : '0 0 66.667%',
                    position: 'relative',
                    overflow: 'hidden',
                    flexGrow: 1,
                    flexShrink: 0,
                    minHeight: 0,
                }}
            >
                <MessageDisplay
                    selectedConversation={selectedConversation}
                    onBack={handleBack}
                    setConversations={setConversations}
                    setSelectedConversation={setSelectedConversation}
                    screens={screens}
                />
            </div>
        </Flex>
    );
};

export default Index;